var exports = {
  "kL": "x8b4e8595--b0c1d2--container",
  "Kk": "x8b4e8595--b0c1d2--icon",
  "UU": "x8b4e8595--b0c1d2--name",
};

module.exports = exports;
